import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePageTitleStore = defineStore('pageTitle', () => {
  const pageTitle = ref(null);

  return { pageTitle };
});
